import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=5ec20a3a&scoped=true"
import script from "./Newsletter.vue?vue&type=script&lang=js"
export * from "./Newsletter.vue?vue&type=script&lang=js"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=5ec20a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec20a3a",
  null
  
)

export default component.exports